import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import http from "../../utils/http";

const initialState = {
  isLoading: false,
  users: [],
};

export const getSidekickUsers = createAsyncThunk(
  "application/getSidekickUsers",
  async (payload, thunkAPI) => {
    try {
      const response = await http.get(
        `${
          process.env.REACT_APP_API_SIDEKICK_BASE_URL
        }/get-all-sidekick-users?limit=${20}&page=${
          payload?.currentPage
        }&searchVal=${payload?.debouncedSearchTerm}&sortBy=${
          payload?.sortBy && payload?.sortBy
        }&sortOrder=${payload?.sortOrder && payload?.sortOrder}`
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addTicketsCount = createAsyncThunk(
  "application/addTicketsCount",
  async (payload, thunkAPI) => {
    try {
      const response = await http.post(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/update-user-tickets`,
        payload
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const giftSubscription = createAsyncThunk(
  "application/giftSubscription",
  async (payload, thunkAPI) => {
    try {
      const response = await http?.post(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/gift-subscription`,
        payload
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const cancelSubscription = createAsyncThunk(
  "application/cancelSubscription",
  async (userId, thunkAPI) => {
    try {
      const response = await http?.post(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/cancel-subscription`,
        userId
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const uploadSubscriptionReport = createAsyncThunk(
  "application/upload-subscription-report",
  async (payload, thunkAPI) => {
    try {
      const response = await http?.post(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/upload-subscription-report/months`,
        payload
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getSubscriptionReport = createAsyncThunk(
  "application/get-sample-subscription-sheet",
  async (type, thunkAPI) => {
    try {
      const response = await http?.get(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/get-sample-subscription-sheet/months`,
        { responseType: 'blob' }
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const sidekickUserSlice = createSlice({
  name: "sidekick-users",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSidekickUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSidekickUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.users = action.payload;
      })
      .addCase(getSidekickUsers.rejected, (state) => {
        state.isLoading = false;
        state.users = [];
      })
      .addCase(addTicketsCount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addTicketsCount.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(addTicketsCount.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(giftSubscription.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(giftSubscription.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(giftSubscription.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(cancelSubscription.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(cancelSubscription.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(cancelSubscription.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getSubscriptionReport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSubscriptionReport.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getSubscriptionReport.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(uploadSubscriptionReport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadSubscriptionReport.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(uploadSubscriptionReport.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default sidekickUserSlice.reducer;
